import React, { useState, useEffect, useCallback } from "react";
import { getPostsWithCorrections } from "../services/posts";
import { RESTPost } from "../services/types";
import BDPost from "../components/BDPost";
import PostSkeleton from "../components/PostSkeleton";
import Button from "../components/Button";

const ModerationCorrectionsPage: React.FC = () => {
    const [posts, setPosts] = useState<RESTPost[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const loadPosts = useCallback(async (page: number, append: boolean = false) => {
        setLoading(true);
        setError(null);
        
        try {
            const response = await getPostsWithCorrections(page);
            
            if (append) {
                setPosts(prevPosts => [...prevPosts, ...response.posts]);
            } else {
                setPosts(response.posts);
            }
            
            setTotalPages(response.totalPages);
        } catch (err) {
            setError('Failed to load posts');
            console.error('Error loading posts with corrections:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    const loadMorePosts = useCallback(() => {
        if (currentPage < totalPages && !loading) {
            const nextPage = currentPage + 1;
            setCurrentPage(nextPage);
            loadPosts(nextPage, true);
        }
    }, [currentPage, totalPages, loading, loadPosts]);

    // Load initial posts
    useEffect(() => {
        loadPosts(1);
    }, [loadPosts]);

    const hasMorePosts = currentPage < totalPages;

    return (
        <>
            {loading && posts.length === 0 ? (
                <PostSkeleton count={5} />
            ) : (
                posts.map((post: RESTPost) => (
                    <BDPost key={post.id} post={post} />
                ))
            )}
            
            {hasMorePosts && (
                <div style={{ textAlign: 'center', padding: '2rem' }}>
                    <Button 
                        variant="secondary" 
                        size="medium" 
                        onClick={loadMorePosts}
                        loading={loading}
                    >
                        {loading ? 'Chargement...' : 'Charger plus de BDs'}
                    </Button>
                </div>
            )}
            
            {error && (
                <div style={{ textAlign: 'center', padding: '2rem', color: 'red' }}>
                    {error}
                </div>
            )}
            
            {!loading && posts.length === 0 && (
                <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
                    Aucune BD avec une correction orthographique !
                </div>
            )}
            
            {!hasMorePosts && posts.length > 0 && (
                <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
                    Aucune autre BD avec une correction orthographique !
                </div>
            )}
        </>
    );
};

export default ModerationCorrectionsPage;
